import axiosInstance from "../axiosInstance";
import API_ROUTES from "../apiRoutes";

export const DiamondAPI = {
  upload: (formData) =>
    axiosInstance.post(API_ROUTES.DIAMOND.UPLOAD, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getRates: (page, limit, search) => {
    return axiosInstance.get(
      `${API_ROUTES.DIAMOND.GET_RATES}?page=${page}&limit=${limit}&search=${search}`,
    );
  },
  addRate: (rateData) =>
    axiosInstance.post(API_ROUTES.DIAMOND.ADD_RATE, rateData),
  updateRate: (id, rateData) =>
    axiosInstance.put(`${API_ROUTES.DIAMOND.UPDATE_RATE}/${id}`, rateData),
  deleteRate: (rateId) =>
    axiosInstance.delete(`${API_ROUTES.DIAMOND.DELETE_RATE}/${rateId}`),
};
